import { render, staticRenderFns } from "./OaAdmin.vue?vue&type=template&id=336e28d6&scoped=true"
import script from "./OaAdmin.vue?vue&type=script&lang=js"
export * from "./OaAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336e28d6",
  null
  
)

export default component.exports